const messages = {
    menuTitle: 'Wiki',
    pageTitle: 'Wiki',
    errors: {
        fetchRootFolders: 'Nie udało się pobrać folderów głównych.',
        search: 'Nie udało się wyszukać.',
        fetchFolderContent: 'Nie udało się pobrać zawartości folderu.',
        createFolder: 'Nie udało się utworzyć folderu.',
        updateFolder: 'Nie udało się zaktualizować folderu.',
        deleteFolder: 'Nie udało się usunąć folderu.',
        fetchEntry: 'Nie udało się pobrać wpisu.',
        createEntry: 'Nie udało się utworzyć wpisu.',
        createEntryNoFolder: 'Wybierz folder lub wejdź do folderu, w którym chcesz utworzyć wpis.',
        updateEntry: 'Nie udało się zaktualizować wpisu.',
        deleteEntry: 'Nie udało się usunąć wpisu.',
        createAttachment: 'Nie udało się dodać załącznika.',
        createAttachmentNoFolder: 'Wybierz folder lub wejdź do folderu, w którym chcesz dodać plik.',
        updateAttachment: 'Nie udało się zaktualizować załącznika.',
        deleteAttachment: 'Nie udało się usunąć załącznika.',
        downloadAttachment: 'Nie udało się pobrać załącznika.',
        openAttachment: 'Nie udało się otworzyć załącznika.',
        copyAttachmentLink: 'Nie udało się skopiować adresu odnośnika.',
        duplicateAttachmentName: 'Załącznik o nazwie „{name}” już istnieje.'
    },
    notifications: {
        folderCreated: 'Folder został utworzony.',
        folderRenamed: 'Nazwa folderu została zmieniona.',
        folderMoved: 'Folder został przeniesiony.',
        folderDeleted: 'Folder został usunięty.',
        entryCreated: 'Wpis został utworzony.',
        entryUpdated: 'Wpis został zaktualizowany.',
        entryRenamed: 'Nazwa wpisu została zmieniona.',
        entryMoved: 'Wpis został przeniesiony.',
        entryDeleted: 'Wpis został usunięty.',
        attachmentCreated: 'Załącznik został dodany.',
        attachmentRenamed: 'Nazwa załącznika została zmieniona.',
        attachmentMoved: 'Plik został przeniesiony.',
        attachmentDeleted: 'Załącznik został usunięty.',
        attachmentLinkCopied: 'Adres odnośnika został skopiowany.'
    },
    actions: {
        newFolder: 'Nowy folder',
        newEntry: 'Nowy wpis',
        uploadFile: 'Prześlij plik',
        openFile: 'Otwórz plik',
        downloadFile: 'Pobierz plik',
        copyFileLink: 'Kopiuj adres odnośnika',
        renameFile: 'Zmień nazwę pliku',
        moveFile: 'Przenieś plik',
        deleteFile: 'Usuń plik',
        renameFolder: 'Zmień nazwę folderu',
        moveFolder: 'Przenieś folder',
        deleteFolder: 'Usuń folder',
        viewEntry: 'Otwórz wpis',
        editEntry: 'Edytuj wpis',
        renameEntry: 'Zmień nazwę wpisu',
        moveEntry: 'Przenieś wpis',
        deleteEntry: 'Usuń wpis'
    },
    dialogs: {
        folderName: {
            createTitle: 'Nowy folder',
            renameTitle: 'Zmień nazwę folderu',
            nameLabel: 'Nazwa folderu',
            namePlaceholder: 'Wprowadź nazwę folderu',
            validation: {
                required: 'Nazwa folderu jest wymagana.',
                maxLength: 'Nazwa folderu może mieć maksymalnie 256 znaków.'
            }
        },
        moveFolder: {
            title: 'Przenieś folder',
            rootFolder: 'Katalog główny',
            noFolders: 'Brak folderów docelowych.',
            selectDestination: 'Wybierz folder docelowy.'
        },
        deleteFolder: {
            title: 'Usuń folder',
            message: 'Czy na pewno chcesz usunąć folder „{name}”?',
            warning:
                'Usunięte zostaną również wszystkie podfoldery, wpisy oraz załączniki znajdujące się w jego strukturze. Tej operacji nie można cofnąć.'
        },
        moveEntry: {
            title: 'Przenieś wpis'
        },
        moveFile: {
            title: 'Przenieś plik'
        },
        deleteFile: {
            title: 'Usuń plik',
            message: 'Czy na pewno chcesz usunąć plik „{name}”?'
        },
        entryName: {
            renameTitle: 'Zmień nazwę wpisu',
            nameLabel: 'Tytuł wpisu',
            namePlaceholder: 'Wprowadź tytuł wpisu',
            validation: {
                required: 'Tytuł wpisu jest wymagany.',
                maxLength: 'Tytuł wpisu może mieć maksymalnie 256 znaków.'
            }
        },
        entryForm: {
            createTitle: 'Nowy wpis',
            editTitle: 'Edytuj wpis',
            nameLabel: 'Tytuł wpisu',
            namePlaceholder: 'Wprowadź tytuł wpisu',
            descriptionLabel: 'Treść wpisu',
            descriptionPlaceholder: 'Wprowadź treść wpisu',
            attachmentsLabel: 'Załączniki',
            attachmentsPlaceholder: 'Wybierz pliki',
            attachmentsSummary: 'Wybrane pliki: {count} ({size})',
            validation: {
                nameRequired: 'Tytuł wpisu jest wymagany.',
                nameMaxLength: 'Tytuł wpisu może mieć maksymalnie 256 znaków.',
                descriptionRequired: 'Treść wpisu jest wymagana.'
            }
        },
        viewEntry: {
            title: 'Podgląd wpisu',
            nameLabel: 'Tytuł wpisu',
            descriptionLabel: 'Treść wpisu'
        },
        attachments: {
            title: 'Załączniki',
            empty: 'Brak załączników.',
            downloadTooltip: 'Pobierz',
            openTooltip: 'Otwórz',
            copyLinkTooltip: 'Kopiuj adres odnośnika',
            renameTooltip: 'Zmień nazwę',
            deleteTooltip: 'Usuń',
            meta: '{date} · {size}'
        },
        attachmentName: {
            renameTitle: 'Zmień nazwę załącznika',
            fileRenameTitle: 'Zmień nazwę pliku',
            nameLabel: 'Nazwa załącznika',
            namePlaceholder: 'Wprowadź nazwę załącznika',
            validation: {
                required: 'Nazwa załącznika jest wymagana.',
                maxLength: 'Nazwa załącznika może mieć maksymalnie 512 znaków.'
            }
        },
        deleteAttachment: {
            title: 'Usuń załącznik',
            message: 'Czy na pewno chcesz usunąć załącznik „{name}”?'
        },
        deleteEntry: {
            title: 'Usuń wpis',
            message: 'Czy na pewno chcesz usunąć wpis „{name}”?'
        }
    },
    fileManager: {
        lang: 'pl-PL',
        calendar: {
            monthFull: [
                'Styczeń',
                'Luty',
                'Marzec',
                'Kwiecień',
                'Maj',
                'Czerwiec',
                'Lipiec',
                'Sierpień',
                'Wrzesień',
                'Październik',
                'Listopad',
                'Grudzień'
            ],
            monthShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
            dayFull: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
            dayShort: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
            hours: 'Godziny',
            minutes: 'Minuty',
            done: 'Gotowe',
            clear: 'Wyczyść',
            today: 'Dziś',
            am: ['am', 'AM'],
            pm: ['pm', 'PM'],
            weekStart: 1,
            clockFormat: 24
        },
        core: {
            ok: 'OK',
            cancel: 'Anuluj',
            select: 'Wybierz',
            'No data': 'Brak danych',
            'Rows per page': 'Wierszy na stronę',
            'Total pages': 'Liczba stron'
        },
        formats: {
            timeFormat: '%H:%i',
            dateFormat: '%d.%m.%Y',
            monthYearFormat: '%F %Y',
            yearFormat: '%Y'
        },
        filemanager: {
            'My files': 'Moje pliki',
            'Add New': 'Dodaj nowy',
            Ok: 'OK',
            Cancel: 'Anuluj',
            'Delete files': 'Usuń pliki',
            Files: 'Pliki',
            Folder: 'Folder',
            'Back to parent folder': 'Wróć do folderu nadrzędnego',
            Information: 'Informacje',
            Found: 'Znaleziono',
            'Are you sure you want to delete these items:': 'Czy na pewno chcesz usunąć te elementy:',
            'Enter file name': 'Wprowadź nazwę pliku',
            'Enter folder name': 'Wprowadź nazwę folderu',
            Result: 'Wynik',
            Search: 'Szukaj',
            'Search results in': 'Wyniki wyszukiwania w',
            'Add new file': 'Dodaj nowy plik',
            'Add new folder': 'Dodaj nowy folder',
            'Upload file': 'Prześlij plik',
            'New file': 'Nowy plik',
            'New folder': 'Nowy folder',
            Size: 'Rozmiar',
            Name: 'Nazwa',
            Type: 'Typ',
            Date: 'Data',
            Rename: 'Zmień nazwę',
            Cut: 'Wytnij',
            Delete: 'Usuń',
            Copy: 'Kopiuj',
            Paste: 'Wklej',
            Download: 'Pobierz',
            Count: 'Liczba',
            folder: 'folder',
            folders: 'foldery',
            file: 'plik',
            files: 'pliki',
            'Multiple files': 'Wiele plików',
            multiple: 'wiele',
            Preview: 'Podgląd',
            of: 'z',
            used: 'użyto',
            'Select file or folder to view details': 'Wybierz plik lub folder, aby zobaczyć szczegóły',
            'Looks like nothing is here': 'Brak elementów do wyświetlenia',
            'Unknown file': 'Nieznany plik',
            'A miniature file preview': 'Miniaturowy podgląd pliku'
        }
    }
}

export default {
    messages,
    locale: 'pl'
}
